export default "__VITE_ASSET__DZhntftS__"